import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule, HEADER_CONFIG } from './app/app.module';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from './environments/models/environment.model';

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));


void fetch('./assets/environment-config.json')
  .then((resp) => resp.json())
  .then((config: EnvironmentConfiguration) => {
    platformBrowserDynamic([
      { provide: ENVIRONMENT_CONFIG, useValue: config },
      {
        provide: HEADER_CONFIG,
        useValue: {
          redirectUri: config.redirectURL,
          postLogoutRedirectUri: config.postLogoutRedirectURL,
          clientId: config.clientId,
          authority: config.authority,
          authorityDomain: config.authorityDomain,
          portalURL: config.portal.redirectURL,
        },
      },
    ])
      .bootstrapModule(AppModule)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  });
